import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  keywords,
  canonicalUrl,
  ogImage,
  ogType = "website",
  schemaMarkup,
}) => {
  const siteUrl = "https://hotelsuvidhadeluxe.com";
  const defaultImage = `${siteUrl}/images/hotel-exterior.jpg`;

  const safeTitle =
    typeof title === "string" && title.trim() !== ""
      ? title.trim()
      : "Hotel Suvidha Deluxe Haridwar";

  const safeDescription =
    typeof description === "string" && description.trim() !== ""
      ? description.trim()
      : "Hotel Suvidha Deluxe Haridwar - Best Hotel Near Har Ki Pauri.";

  const safeCanonical = canonicalUrl || siteUrl;

  return (
    <Helmet>
      <title>{"Hotel Suvidha Deluxe Haridwar | Luxuxry Hotel in Haridwar"}</title>

      {/* Primary Meta */}
      <meta name="description" content={safeDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={safeCanonical} />

      {/* Open Graph */}
      <meta property="og:title" content={safeTitle} />
      <meta property="og:description" content={safeDescription} />
      <meta property="og:url" content={safeCanonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={ogImage || defaultImage} />
      <meta property="og:site_name" content="Hotel Suvidha Deluxe" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={safeTitle} />
      <meta name="twitter:description" content={safeDescription} />
      <meta name="twitter:image" content={ogImage || defaultImage} />

      {/* Geo + Author */}
      <meta name="geo.region" content="IN-UT" />
      <meta name="geo.placename" content="Haridwar" />
      <meta name="geo.position" content="29.9457;78.1642" />
      <meta name="ICBM" content="29.9457,78.1642" />
      <meta name="author" content="Hotel Suvidha Deluxe" />

      {/* Robots */}
      <meta
        name="robots"
        content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
      />
      <meta name="googlebot" content="index, follow" />

      {/* PWA / Apple */}
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="apple-mobile-web-app-title" content="Hotel Suvidha Deluxe" />

      {/* Schema */}
      {schemaMarkup && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schemaMarkup),
          }}
        />
      )}
    </Helmet>
  );
};

export default SEO;